<div class="modal-backdrop fade"
     [class.show]="show"></div>
<div class="modal d-block fade"
     [class.show]="show"
     tabindex="-1"
     role="dialog"
     aria-labelledby="modalIdLabel">
  <div role="document"
       class="modal-dialog modal-dialog-centered"
       style="max-width: 50%">
    <div class="modal-content"
         style="min-height: 60vh">
      <div class="modal-header">
        <h5 class="modal-title text-primary-dark">{{category?category.name:"New Category"}}</h5>
        <button type="button"
                class="close"
                (click)="close()"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="serviceCategoryFormGroup"
            (submit)="onSubmit()">
        <div class="modal-body">
          <div class="form-group">
            <label for="name"
                   required>Category Name</label>
            <input type="text"
                   class="form-control"
                   formControlName="name"
                   id="name"
                   aria-describedby="producthelp" />
            <div *ngIf="
                 categoryFormControl.name.touched && !categoryFormControl.name.valid
                 "
                 class="error_message">
              <span *ngIf="categoryFormControl.name.errors"
                    class="text-danger">
                Enter a valid name
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="description"
                   required>Description</label>
            <textarea class="form-control"
                      formControlName="description"
                      id="description"></textarea>
            <div *ngIf="
            categoryFormControl.description.touched && !categoryFormControl.description.valid
            "
                 class="error_message">
              <span *ngIf="categoryFormControl.description.errors"
                    class="text-danger">
                Enter a valid description
              </span>
            </div>
          </div>
          <div class="form-group">
            <label for="name"
                   required>Icon(SVG)</label>
            <input type="file"
                   class="form-control-file pb-1 d-none"
                   id="image"
                   #image
                   accept="image/svg"
                   [disabled]="uploadingImage"
                   (change)="previewImage($event, categoryFormControl.icon)">
            <label for="icon_image"
                   class="d-block"
                   (click)="image.click()">
              <img [src]="iconUrl"
                   class="icon-preview"
                   alt="{{categoryFormControl.name.value}}"
                   width="100">
            </label>
            <div *ngIf="uploadingImage"
                 class="spinner-border spinner-border-sm text-primary"
                 role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="custom-control custom-checkbox py-2">
            <input type="checkbox"
                   id="event"
                   formControlName="is_event"
                   class="custom-control-input">
            <label for="event"
                   class="custom-control-label">Is Event Category</label>
          </div>
          <div class="custom-control custom-checkbox py-2">
            <input type="checkbox"
                   id="published"
                   formControlName="published"
                   class="custom-control-input">
            <label for="published"
                   class="custom-control-label">Publish</label>
          </div>
          <div class="modal-footer">
            <button type="button"
                    class="btn btn-secondary"
                    (click)="close()">
              Close
            </button>
            <button type="submit"
                    appSpinner
                    [isLoading]="uploadingImage||isLoading"
                    [disabled]="!serviceCategoryFormGroup.valid||uploadingImage||isLoading"
                    class="btn btn-primary">Save Category</button>
          </div>
        </div>
      </form>

    </div>
  </div>
